import { EHeadingStyleVariant, ELinkVariant, Heading, Link, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import HeroImage1 from '@/assets/gift-cards/hero-1.png';
import HeroImage2 from '@/assets/gift-cards/hero-2.png';
import ScrollMoreSvg from '@/assets/gift-cards/scroll-more.svg';
import MaxWidth from '@/components/common/layout/MaxWidth';
import Button from '@/components/switchback/Button/Button';
import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';
import {
  GIFT_CARDS_BALANACE_CHECKER,
  GIFT_CARDS_HELP,
  GIFTS_URL,
  ORDER_CORPORTATE_GIFT_CARDS,
} from '@/constants/urls';
import { useBreakpoint } from '@/hooks/useBreakpoint';

type TLinkComponent = {
  href: string;
  children: React.ReactNode;
};

const LinkComponent = ({ href, children }: TLinkComponent) => {
  const { isMobile } = useBreakpoint();
  return (
    <Link
      href={href}
      variant={ELinkVariant.Underline}
      rel="noreferrer"
      target={!isMobile ? '_blank' : undefined}>
      {children}
    </Link>
  );
};

export const Hero = () => {
  const { isMobile } = useBreakpoint();

  return (
    <section>
      <div className="flex justify-center min-h-[calc(100vh-72px)] md:h-auto md:min-h-screen bg-canvas-100">
        <MaxWidth className="flex items-center justify-between my-auto md:mt-20 md:mb-0">
          <div className="flex flex-col items-center justify-start text-center gap-2 md:justify-center lg:flex-wrap md:my-auto">
            <Heading
              className="font-semibold md:font-bold leading-900 md:leading-none"
              variant={EHeadingStyleVariant.H1}>
              <FormattedMessage id="MCJsex" defaultMessage="Introducing Outdoorsy Gift cards" />
            </Heading>
            <Text className="mt-2 text-3xl italic font-semibold font-[Abril-Titling]">
              <FormattedMessage defaultMessage="Share your love of the outdoors" id="lMuR03" />
            </Text>
            <div className="relative flex justify-center w-92 md:w-[800px] h-36 md:h-[300px]">
              <ResponsiveImage
                src={HeroImage1.src}
                alt="Outdoorsy gift card"
                className="absolute z-10 h-auto left-4 md:left-5 w-[186px] md:w-[420px]"
                priority={true}
                withFetchPriority="high"
              />
              <ResponsiveImage
                src={HeroImage2.src}
                alt="Outdoorsy gift card"
                className="absolute z-20 h-auto right-5 top-3 md:right-5 w-[186px] md:w-[420px] md:top-5"
                priority={true}
                withFetchPriority="high"
              />
            </div>
            <div className="flex flex-col items-center my-5 gap-5 lg:my-10">
              <Button
                href={GIFTS_URL}
                rel="noreferrer"
                target={!isMobile ? '_blank' : undefined}
                className="w-44">
                <FormattedMessage defaultMessage="Start gifting" id="4OwdQh" />
              </Button>
              <div>
                <FormattedMessage
                  defaultMessage="<CheckBalanceLink>Check balance</CheckBalanceLink>, <GetHelpLink>Get help</GetHelpLink>, or <OrderCorporate>Order corporate gift cards</OrderCorporate>"
                  id="FqDcMX"
                  values={{
                    CheckBalanceLink: text => (
                      <LinkComponent href={GIFT_CARDS_BALANACE_CHECKER}>{text}</LinkComponent>
                    ),
                    GetHelpLink: text => (
                      <LinkComponent href={GIFT_CARDS_HELP}>{text}</LinkComponent>
                    ),
                    OrderCorporate: text => (
                      <LinkComponent href={ORDER_CORPORTATE_GIFT_CARDS}>{text}</LinkComponent>
                    ),
                  }}
                />
              </div>
            </div>
            <div className="mb-5">
              <ScrollMoreSvg />
            </div>
          </div>
        </MaxWidth>
      </div>
    </section>
  );
};
